import { APIPersonalAutoApplicationFormVehicle } from 'types/api.types';
import { BinderSectionData } from '../hooks/useBinderSectionData';
import { processValidation, validateFailedObjects } from '../utils/helpers';

export const processTypeOfFuelData = (
  vehicles: APIPersonalAutoApplicationFormVehicle[],
  remarks: Remark[],
  validation?: Validation,
): BinderSectionData => {
  const processedTypeOfFuelData = {
    vehicles: vehicles.map((vehicle, index: number) => {
      const isValid = validateFailedObjects(index, validation);
      // Determine fuel type based on is_diesel, is_gas, and other_fuel_type
      let fuelType = 'Not specified';
      if (vehicle?.is_diesel) {
        fuelType = 'Diesel';
      } else if (vehicle?.is_gas) {
        fuelType = 'Gas';
      } else if (vehicle?.other_fuel_type) {
        fuelType = vehicle.other_fuel_type;
      }

      return {
        index: index + 1,
        name:
          vehicle?.make && vehicle?.model
            ? `${vehicle.make} ${vehicle.model}`
            : `Vehicle ${index + 1}`,
        fuelType,
        remarks: remarks.find((r) => r.item_key === `vehicle-${index + 1}`)
          ?.text,
        isValid,
      };
    }),
  };

  const validationData = processValidation(validation);

  return {
    title: 'Type of fuel',
    description: 'Record the type of fuel used by each vehicle.',
    isValid: validationData.isValid,
    message: validationData.message,
    data: processedTypeOfFuelData,
  };
};
